import {loadStripe} from '@stripe/stripe-js';
import {getSetting} from '@wc-stripe/utils';

let stripeSDKPromise = null;
let cachedPublicKey = null;
let cachedSdkParams = null;

/**
 * Load Stripe SDK
 *
 * Returns cached Stripe instance if public_key and sdkParams haven't changed.
 * Reloads SDK if parameters change (e.g., switching between test/live mode).
 *
 * @returns {Promise<Stripe>} Stripe instance
 */
const loadStripeSDK = async () => {
    const publicKey = getSetting('publicKey');
    const sdkParams = getSetting('sdkParams');

    // Check if SDK needs to be reloaded due to parameter changes
    const paramsChanged = cachedPublicKey !== publicKey ||
        JSON.stringify(cachedSdkParams) !== JSON.stringify(sdkParams);

    if (!stripeSDKPromise || paramsChanged) {
        try {
            // Store current parameters
            cachedPublicKey = publicKey;
            cachedSdkParams = sdkParams;

            // Load Stripe SDK with current parameters
            stripeSDKPromise = loadStripe(publicKey, sdkParams);
        } catch (error) {
            throw error;
        }
    }

    return stripeSDKPromise;
}

export {
    loadStripeSDK
}